// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --navy: #0d1b3e;
  --navy-mid: #1a2f5e;
  --teal: #00c2a8;
  --teal-light: #00e5c8;
  --teal-dim: #00c2a820;
  --sky: #e8f4ff;
  --sky-mid: #c8e6ff;
  --cream: #f7f9fc;
  --white: #ffffff;
  --text-dark: #0d1b3e;
  --text-mid: #3a4a6b;
  --text-muted: #7a8baa;
  --border: #dde6f0;
  --accent-amber: #ffb347;
  --font-display: 'Syne', sans-serif;
  --font-body: 'DM Sans', sans-serif;
  --radius-sm: 8px;
  --radius-md: 14px;
  --radius-lg: 24px;
  --radius-xl: 36px;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-body);
  background: var(--cream);
  color: var(--text-dark);
  line-height: 1.65;
  overflow-x: hidden;
}

body,
button,
input,
select,
textarea {
  font-family: var(--font-body);
}

section {
  scroll-margin-top: 88px;
}

button,
a {
  -webkit-tap-highlight-color: transparent;
}

nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(247, 249, 252, 0.92);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6%;
  height: 68px;
}

.nav-logo {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.4rem;
  color: var(--navy);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-logo .dot {
  color: var(--teal);
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-links a {
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-mid);
  transition: color 0.2s;
}

.nav-links a:hover {
  color: var(--teal);
}

.nav-cta {
  background: var(--navy);
  color: var(--white) !important;
  padding: 9px 22px;
  border-radius: 50px;
  font-weight: 600 !important;
  transition: background 0.2s !important;
}

.nav-cta:hover {
  background: var(--navy-mid) !important;
  color: var(--white) !important;
}

.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 120px 6% 80px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(160deg, #ebf5ff 0%, #f7f9fc 50%, #e8fbf8 100%);
}

.hero::before {
  content: '';
  position: absolute;
  top: -200px;
  right: -200px;
  width: 700px;
  height: 700px;
  background: radial-gradient(circle, rgba(0, 194, 168, 0.12) 0%, transparent 70%);
  border-radius: 50%;
}

.hero::after {
  content: '';
  position: absolute;
  bottom: -150px;
  left: -100px;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(13, 27, 62, 0.06) 0%, transparent 70%);
  border-radius: 50%;
}

.hero-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  position: relative;
  z-index: 2;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--teal-dim);
  border: 1px solid rgba(0, 194, 168, 0.3);
  color: #007a6a;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 50px;
  margin-bottom: 1.5rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.badge-dot {
  width: 7px;
  height: 7px;
  background: var(--teal);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.hero h1 {
  font-family: var(--font-display);
  font-size: clamp(2.4rem, 4vw, 3.6rem);
  font-weight: 800;
  line-height: 1.1;
  color: var(--navy);
  margin-bottom: 1.25rem;
}

.hero h1 span {
  color: var(--teal);
}

.hero p {
  font-size: 1.1rem;
  color: var(--text-mid);
  max-width: 480px;
  margin-bottom: 2.5rem;
  line-height: 1.75;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
}

.btn-primary,
.btn-secondary,
.btn-cta-primary,
.btn-cta-ghost,
.whatsapp-btn,
.form-submit {
  transition: all 0.25s;
}

.btn-primary {
  background: var(--navy);
  color: var(--white);
  padding: 14px 30px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary:hover {
  background: var(--teal);
  transform: translateY(-2px);
}

.btn-secondary {
  background: transparent;
  color: var(--navy);
  padding: 14px 28px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  border: 2px solid var(--border);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-secondary:hover {
  border-color: var(--navy);
  background: var(--sky);
}

.hero-visual {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  animation: floatIn 0.8s ease-out both;
}

@keyframes floatIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 18px;
  box-shadow: 0 4px 24px rgba(13, 27, 62, 0.06);
  transition: transform 0.3s;
}

.hero-card:hover {
  transform: translateY(-4px);
}

.hero-card.tall {
  grid-row: span 2;
}

.hero-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.ic-teal {
  background: rgba(0, 194, 168, 0.12);
  color: var(--teal);
}

.ic-navy {
  background: rgba(13, 27, 62, 0.08);
  color: var(--navy);
}

.ic-amber {
  background: rgba(255, 179, 71, 0.15);
  color: #c87d00;
}

.hero-card h4 {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--navy);
  margin-bottom: 4px;
}

.hero-card p {
  font-size: 0.75rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.stat-big {
  font-family: var(--font-display);
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--teal);
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 0.78rem;
  color: var(--text-muted);
}

.chat-bubble {
  background: var(--sky);
  border-radius: 12px 12px 12px 2px;
  padding: 10px 14px;
  font-size: 0.78rem;
  color: var(--text-mid);
  margin-bottom: 8px;
  position: relative;
}

.chat-bubble.reply {
  background: var(--teal);
  color: var(--white);
  border-radius: 12px 12px 2px 12px;
  align-self: flex-end;
}

.chat-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.typing-dots {
  display: flex;
  gap: 4px;
  padding: 6px;
}

.typing-dot {
  width: 6px;
  height: 6px;
  background: var(--text-muted);
  border-radius: 50%;
  animation: typeDot 1.2s infinite;
}

.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typeDot {
  0%,
  80%,
  100% {
    transform: scale(0.7);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.logos {
  padding: 2.5rem 6%;
  background: var(--white);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

.logos-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 2.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.logos-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.logo-chip {
  background: var(--cream);
  border: 1px solid var(--border);
  border-radius: 50px;
  padding: 8px 20px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-mid);
  display: flex;
  align-items: center;
  gap: 7px;
}

.logo-chip svg {
  width: 18px;
  height: 18px;
}

section {
  padding: 90px 6%;
}

.section-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.section-tag {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--teal);
  margin-bottom: 0.75rem;
}

.section-title {
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 3vw, 2.7rem);
  font-weight: 700;
  color: var(--navy);
  line-height: 1.15;
  margin-bottom: 1rem;
}

.section-sub {
  font-size: 1.05rem;
  color: var(--text-mid);
  max-width: 600px;
  line-height: 1.75;
}

.problema {
  background: var(--navy);
}

.problema .section-title {
  color: var(--white);
}

.problema .section-sub {
  color: rgba(255, 255, 255, 0.65);
}

.problema .section-tag {
  color: var(--teal-light);
}

.pain-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 16px;
  margin-top: 3rem;
}

.pain-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-md);
  padding: 24px;
}

.pain-icon {
  font-size: 1.6rem;
  margin-bottom: 12px;
}

.pain-card h4 {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--white);
  margin-bottom: 6px;
}

.pain-card p {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.6;
}

.servicios {
  background: var(--cream);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 3.5rem;
}

.service-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 32px;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.service-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--teal);
  opacity: 0;
  transition: opacity 0.3s;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 48px rgba(13, 27, 62, 0.1);
}

.service-card:hover::before {
  opacity: 1;
}

.service-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--sky);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.service-card h3 {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--navy);
  margin-bottom: 10px;
}

.service-card p {
  font-size: 0.88rem;
  color: var(--text-mid);
  line-height: 1.7;
  margin-bottom: 16px;
}

.service-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  background: var(--sky);
  color: var(--navy);
  font-size: 0.73rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 50px;
  border: 1px solid var(--sky-mid);
}

.proceso {
  background: var(--white);
}

.steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  margin-top: 3.5rem;
  position: relative;
}

.steps::before {
  content: '';
  position: absolute;
  top: 32px;
  left: 10%;
  right: 10%;
  height: 2px;
  background: linear-gradient(90deg, var(--teal) 0%, var(--sky-mid) 100%);
  z-index: 0;
}

.step {
  text-align: center;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.step-num {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--navy);
  color: var(--white);
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  border: 4px solid var(--cream);
}

.step:nth-child(1) .step-num {
  background: var(--teal);
}

.step h4 {
  font-size: 0.92rem;
  font-weight: 700;
  color: var(--navy);
  margin-bottom: 8px;
}

.step p {
  font-size: 0.82rem;
  color: var(--text-muted);
  line-height: 1.6;
}

.stats {
  background: linear-gradient(135deg, #ebf5ff 0%, #e8fbf8 100%);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  margin-top: 3rem;
}

.stat-card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 28px 24px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.04);
}

.stat-card .num {
  font-family: var(--font-display);
  font-size: 2.8rem;
  font-weight: 800;
  color: var(--navy);
  line-height: 1;
  margin-bottom: 8px;
}

.stat-card .num span {
  color: var(--teal);
}

.stat-card .desc {
  font-size: 0.87rem;
  color: var(--text-mid);
  line-height: 1.5;
}

.testimonios {
  background: var(--cream);
}

.testimonios-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 3rem;
}

.testimonial {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 28px;
}

.stars {
  color: var(--accent-amber);
  font-size: 0.95rem;
  margin-bottom: 14px;
  letter-spacing: 2px;
}

.testimonial blockquote {
  font-size: 0.92rem;
  color: var(--text-mid);
  line-height: 1.75;
  font-style: italic;
  margin-bottom: 20px;
  border: none;
  padding: 0;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 12px;
}

.author-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
  flex-shrink: 0;
}

.av-1 {
  background: rgba(0, 194, 168, 0.15);
  color: var(--teal);
}

.av-2 {
  background: rgba(13, 27, 62, 0.1);
  color: var(--navy);
}

.av-3 {
  background: rgba(255, 179, 71, 0.15);
  color: #c87d00;
}

.author-name {
  font-weight: 600;
  font-size: 0.88rem;
  color: var(--navy);
}

.author-biz {
  font-size: 0.78rem;
  color: var(--text-muted);
}

.cta-section {
  background: var(--navy);
  padding: 90px 6%;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: -150px;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 500px;
  background: radial-gradient(circle, rgba(0, 194, 168, 0.15) 0%, transparent 70%);
  border-radius: 50%;
}

.cta-section h2 {
  font-family: var(--font-display);
  font-size: clamp(1.9rem, 3.5vw, 3rem);
  font-weight: 800;
  color: var(--white);
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}

.cta-section h2 span {
  color: var(--teal-light);
}

.cta-section p {
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.6);
  max-width: 520px;
  margin: 0 auto 2.5rem;
  line-height: 1.75;
  position: relative;
  z-index: 1;
}

.cta-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
}

.btn-cta-primary {
  background: var(--teal);
  color: var(--navy);
  padding: 15px 34px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-cta-primary:hover {
  background: var(--teal-light);
  transform: translateY(-2px);
}

.btn-cta-ghost {
  background: transparent;
  color: var(--white);
  padding: 15px 34px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  border: 2px solid rgba(255, 255, 255, 0.25);
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-cta-ghost:hover {
  border-color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.05);
}

.contacto {
  background: var(--white);
}

.contacto-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  align-items: start;
  max-width: 1100px;
  margin: 0 auto;
}

.form-wrap {
  background: var(--cream);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 36px;
}

.form-group {
  margin-bottom: 18px;
}

.form-group label {
  display: block;
  font-size: 0.83rem;
  font-weight: 600;
  color: var(--text-mid);
  margin-bottom: 6px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
  color: var(--text-dark);
  background: var(--white);
  outline: none;
  transition: border-color 0.2s;
  appearance: none;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: var(--teal);
}

.form-group textarea {
  resize: vertical;
  min-height: 110px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.form-submit {
  width: 100%;
  padding: 14px;
  background: var(--navy);
  color: var(--white);
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
}

.form-submit:hover:not(:disabled) {
  background: var(--teal);
  color: var(--navy);
}

.form-submit:disabled {
  cursor: default;
  opacity: 0.96;
}

.contact-info h3 {
  font-family: var(--font-display);
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--navy);
  margin-bottom: 1rem;
}

.contact-info p {
  color: var(--text-mid);
  font-size: 0.95rem;
  line-height: 1.75;
  margin-bottom: 2rem;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
}

.ci-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: var(--sky);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.ci-text p {
  font-size: 0.82rem;
  color: var(--text-muted);
  margin-bottom: 2px;
}

.ci-text strong {
  font-size: 0.9rem;
  color: var(--navy);
}

.whatsapp-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #25d366;
  color: var(--white);
  padding: 13px 26px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.9rem;
  text-decoration: none;
  margin-top: 0.5rem;
}

.whatsapp-btn:hover {
  background: #1eb85a;
  transform: translateY(-2px);
}

footer {
  background: var(--navy);
  color: rgba(255, 255, 255, 0.5);
  padding: 2rem 6%;
  text-align: center;
  font-size: 0.82rem;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-logo {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.1rem;
  color: var(--white);
}

.footer-logo span {
  color: var(--teal);
}

footer a {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
}

footer a:hover {
  color: var(--teal);
}

.fade-up {
  opacity: 0;
  transform: translateY(28px);
  animation: fadeUp 0.6s ease-out forwards;
}

@keyframes fadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.delay-1 {
  animation-delay: 0.1s;
}

.delay-2 {
  animation-delay: 0.2s;
}

.delay-3 {
  animation-delay: 0.3s;
}

@media (max-width: 900px) {
  .hero-inner {
    grid-template-columns: 1fr;
  }

  .hero-visual {
    max-width: 500px;
    margin: 0 auto;
  }

  .steps {
    grid-template-columns: 1fr 1fr;
  }

  .steps::before {
    display: none;
  }

  .contacto-inner {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 650px) {
  nav {
    padding: 0 4%;
  }

  .nav-links {
    display: none;
  }

  section {
    padding: 60px 5%;
  }

  .hero {
    padding: 100px 5% 60px;
  }

  .steps {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .hero h1 {
    font-size: 2.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,uEAAuE;EACvE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --navy: #0d1b3e;\n  --navy-mid: #1a2f5e;\n  --teal: #00c2a8;\n  --teal-light: #00e5c8;\n  --teal-dim: #00c2a820;\n  --sky: #e8f4ff;\n  --sky-mid: #c8e6ff;\n  --cream: #f7f9fc;\n  --white: #ffffff;\n  --text-dark: #0d1b3e;\n  --text-mid: #3a4a6b;\n  --text-muted: #7a8baa;\n  --border: #dde6f0;\n  --accent-amber: #ffb347;\n  --font-display: 'Syne', sans-serif;\n  --font-body: 'DM Sans', sans-serif;\n  --radius-sm: 8px;\n  --radius-md: 14px;\n  --radius-lg: 24px;\n  --radius-xl: 36px;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-body);\n  background: var(--cream);\n  color: var(--text-dark);\n  line-height: 1.65;\n  overflow-x: hidden;\n}\n\nbody,\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: var(--font-body);\n}\n\nsection {\n  scroll-margin-top: 88px;\n}\n\nbutton,\na {\n  -webkit-tap-highlight-color: transparent;\n}\n\nnav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  background: rgba(247, 249, 252, 0.92);\n  backdrop-filter: blur(16px);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 6%;\n  height: 68px;\n}\n\n.nav-logo {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 1.4rem;\n  color: var(--navy);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.nav-logo .dot {\n  color: var(--teal);\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.nav-links a {\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-mid);\n  transition: color 0.2s;\n}\n\n.nav-links a:hover {\n  color: var(--teal);\n}\n\n.nav-cta {\n  background: var(--navy);\n  color: var(--white) !important;\n  padding: 9px 22px;\n  border-radius: 50px;\n  font-weight: 600 !important;\n  transition: background 0.2s !important;\n}\n\n.nav-cta:hover {\n  background: var(--navy-mid) !important;\n  color: var(--white) !important;\n}\n\n.hero {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  padding: 120px 6% 80px;\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(160deg, #ebf5ff 0%, #f7f9fc 50%, #e8fbf8 100%);\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: -200px;\n  right: -200px;\n  width: 700px;\n  height: 700px;\n  background: radial-gradient(circle, rgba(0, 194, 168, 0.12) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.hero::after {\n  content: '';\n  position: absolute;\n  bottom: -150px;\n  left: -100px;\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(13, 27, 62, 0.06) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.hero-inner {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n  position: relative;\n  z-index: 2;\n}\n\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--teal-dim);\n  border: 1px solid rgba(0, 194, 168, 0.3);\n  color: #007a6a;\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 50px;\n  margin-bottom: 1.5rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.badge-dot {\n  width: 7px;\n  height: 7px;\n  background: var(--teal);\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.3;\n  }\n}\n\n.hero h1 {\n  font-family: var(--font-display);\n  font-size: clamp(2.4rem, 4vw, 3.6rem);\n  font-weight: 800;\n  line-height: 1.1;\n  color: var(--navy);\n  margin-bottom: 1.25rem;\n}\n\n.hero h1 span {\n  color: var(--teal);\n}\n\n.hero p {\n  font-size: 1.1rem;\n  color: var(--text-mid);\n  max-width: 480px;\n  margin-bottom: 2.5rem;\n  line-height: 1.75;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.btn-primary,\n.btn-secondary,\n.btn-cta-primary,\n.btn-cta-ghost,\n.whatsapp-btn,\n.form-submit {\n  transition: all 0.25s;\n}\n\n.btn-primary {\n  background: var(--navy);\n  color: var(--white);\n  padding: 14px 30px;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-primary:hover {\n  background: var(--teal);\n  transform: translateY(-2px);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: var(--navy);\n  padding: 14px 28px;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  text-decoration: none;\n  border: 2px solid var(--border);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-secondary:hover {\n  border-color: var(--navy);\n  background: var(--sky);\n}\n\n.hero-visual {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  animation: floatIn 0.8s ease-out both;\n}\n\n@keyframes floatIn {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hero-card {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 18px;\n  box-shadow: 0 4px 24px rgba(13, 27, 62, 0.06);\n  transition: transform 0.3s;\n}\n\n.hero-card:hover {\n  transform: translateY(-4px);\n}\n\n.hero-card.tall {\n  grid-row: span 2;\n}\n\n.hero-card-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  margin-bottom: 10px;\n}\n\n.ic-teal {\n  background: rgba(0, 194, 168, 0.12);\n  color: var(--teal);\n}\n\n.ic-navy {\n  background: rgba(13, 27, 62, 0.08);\n  color: var(--navy);\n}\n\n.ic-amber {\n  background: rgba(255, 179, 71, 0.15);\n  color: #c87d00;\n}\n\n.hero-card h4 {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--navy);\n  margin-bottom: 4px;\n}\n\n.hero-card p {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.stat-big {\n  font-family: var(--font-display);\n  font-size: 2.2rem;\n  font-weight: 800;\n  color: var(--teal);\n  line-height: 1;\n  margin-bottom: 4px;\n}\n\n.stat-label {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n\n.chat-bubble {\n  background: var(--sky);\n  border-radius: 12px 12px 12px 2px;\n  padding: 10px 14px;\n  font-size: 0.78rem;\n  color: var(--text-mid);\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.chat-bubble.reply {\n  background: var(--teal);\n  color: var(--white);\n  border-radius: 12px 12px 2px 12px;\n  align-self: flex-end;\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.typing-dots {\n  display: flex;\n  gap: 4px;\n  padding: 6px;\n}\n\n.typing-dot {\n  width: 6px;\n  height: 6px;\n  background: var(--text-muted);\n  border-radius: 50%;\n  animation: typeDot 1.2s infinite;\n}\n\n.typing-dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typeDot {\n  0%,\n  80%,\n  100% {\n    transform: scale(0.7);\n    opacity: 0.4;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.logos {\n  padding: 2.5rem 6%;\n  background: var(--white);\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n}\n\n.logos-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 2.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.logos-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  white-space: nowrap;\n}\n\n.logo-chip {\n  background: var(--cream);\n  border: 1px solid var(--border);\n  border-radius: 50px;\n  padding: 8px 20px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--text-mid);\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.logo-chip svg {\n  width: 18px;\n  height: 18px;\n}\n\nsection {\n  padding: 90px 6%;\n}\n\n.section-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.section-tag {\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--teal);\n  margin-bottom: 0.75rem;\n}\n\n.section-title {\n  font-family: var(--font-display);\n  font-size: clamp(1.9rem, 3vw, 2.7rem);\n  font-weight: 700;\n  color: var(--navy);\n  line-height: 1.15;\n  margin-bottom: 1rem;\n}\n\n.section-sub {\n  font-size: 1.05rem;\n  color: var(--text-mid);\n  max-width: 600px;\n  line-height: 1.75;\n}\n\n.problema {\n  background: var(--navy);\n}\n\n.problema .section-title {\n  color: var(--white);\n}\n\n.problema .section-sub {\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.problema .section-tag {\n  color: var(--teal-light);\n}\n\n.pain-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 16px;\n  margin-top: 3rem;\n}\n\n.pain-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: var(--radius-md);\n  padding: 24px;\n}\n\n.pain-icon {\n  font-size: 1.6rem;\n  margin-bottom: 12px;\n}\n\n.pain-card h4 {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--white);\n  margin-bottom: 6px;\n}\n\n.pain-card p {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.55);\n  line-height: 1.6;\n}\n\n.servicios {\n  background: var(--cream);\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-top: 3.5rem;\n}\n\n.service-card {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 32px;\n  transition: all 0.3s;\n  position: relative;\n  overflow: hidden;\n}\n\n.service-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--teal);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.service-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 16px 48px rgba(13, 27, 62, 0.1);\n}\n\n.service-card:hover::before {\n  opacity: 1;\n}\n\n.service-icon-wrap {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: var(--sky);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n}\n\n.service-card h3 {\n  font-family: var(--font-display);\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--navy);\n  margin-bottom: 10px;\n}\n\n.service-card p {\n  font-size: 0.88rem;\n  color: var(--text-mid);\n  line-height: 1.7;\n  margin-bottom: 16px;\n}\n\n.service-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.tag {\n  background: var(--sky);\n  color: var(--navy);\n  font-size: 0.73rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 50px;\n  border: 1px solid var(--sky-mid);\n}\n\n.proceso {\n  background: var(--white);\n}\n\n.steps {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0;\n  margin-top: 3.5rem;\n  position: relative;\n}\n\n.steps::before {\n  content: '';\n  position: absolute;\n  top: 32px;\n  left: 10%;\n  right: 10%;\n  height: 2px;\n  background: linear-gradient(90deg, var(--teal) 0%, var(--sky-mid) 100%);\n  z-index: 0;\n}\n\n.step {\n  text-align: center;\n  padding: 0 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.step-num {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: var(--navy);\n  color: var(--white);\n  font-family: var(--font-display);\n  font-size: 1.3rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n  border: 4px solid var(--cream);\n}\n\n.step:nth-child(1) .step-num {\n  background: var(--teal);\n}\n\n.step h4 {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: var(--navy);\n  margin-bottom: 8px;\n}\n\n.step p {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.stats {\n  background: linear-gradient(135deg, #ebf5ff 0%, #e8fbf8 100%);\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 24px;\n  margin-top: 3rem;\n}\n\n.stat-card {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 28px 24px;\n  text-align: center;\n  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.04);\n}\n\n.stat-card .num {\n  font-family: var(--font-display);\n  font-size: 2.8rem;\n  font-weight: 800;\n  color: var(--navy);\n  line-height: 1;\n  margin-bottom: 8px;\n}\n\n.stat-card .num span {\n  color: var(--teal);\n}\n\n.stat-card .desc {\n  font-size: 0.87rem;\n  color: var(--text-mid);\n  line-height: 1.5;\n}\n\n.testimonios {\n  background: var(--cream);\n}\n\n.testimonios-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n  margin-top: 3rem;\n}\n\n.testimonial {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 28px;\n}\n\n.stars {\n  color: var(--accent-amber);\n  font-size: 0.95rem;\n  margin-bottom: 14px;\n  letter-spacing: 2px;\n}\n\n.testimonial blockquote {\n  font-size: 0.92rem;\n  color: var(--text-mid);\n  line-height: 1.75;\n  font-style: italic;\n  margin-bottom: 20px;\n  border: none;\n  padding: 0;\n}\n\n.testimonial-author {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.author-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n\n.av-1 {\n  background: rgba(0, 194, 168, 0.15);\n  color: var(--teal);\n}\n\n.av-2 {\n  background: rgba(13, 27, 62, 0.1);\n  color: var(--navy);\n}\n\n.av-3 {\n  background: rgba(255, 179, 71, 0.15);\n  color: #c87d00;\n}\n\n.author-name {\n  font-weight: 600;\n  font-size: 0.88rem;\n  color: var(--navy);\n}\n\n.author-biz {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n}\n\n.cta-section {\n  background: var(--navy);\n  padding: 90px 6%;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.cta-section::before {\n  content: '';\n  position: absolute;\n  top: -150px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 800px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(0, 194, 168, 0.15) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.cta-section h2 {\n  font-family: var(--font-display);\n  font-size: clamp(1.9rem, 3.5vw, 3rem);\n  font-weight: 800;\n  color: var(--white);\n  margin-bottom: 1rem;\n  position: relative;\n  z-index: 1;\n}\n\n.cta-section h2 span {\n  color: var(--teal-light);\n}\n\n.cta-section p {\n  font-size: 1.05rem;\n  color: rgba(255, 255, 255, 0.6);\n  max-width: 520px;\n  margin: 0 auto 2.5rem;\n  line-height: 1.75;\n  position: relative;\n  z-index: 1;\n}\n\n.cta-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  position: relative;\n  z-index: 1;\n}\n\n.btn-cta-primary {\n  background: var(--teal);\n  color: var(--navy);\n  padding: 15px 34px;\n  border-radius: 50px;\n  font-weight: 700;\n  font-size: 1rem;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-cta-primary:hover {\n  background: var(--teal-light);\n  transform: translateY(-2px);\n}\n\n.btn-cta-ghost {\n  background: transparent;\n  color: var(--white);\n  padding: 15px 34px;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 1rem;\n  text-decoration: none;\n  border: 2px solid rgba(255, 255, 255, 0.25);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-cta-ghost:hover {\n  border-color: rgba(255, 255, 255, 0.6);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.contacto {\n  background: var(--white);\n}\n\n.contacto-inner {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 5rem;\n  align-items: start;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.form-wrap {\n  background: var(--cream);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 36px;\n}\n\n.form-group {\n  margin-bottom: 18px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 0.83rem;\n  font-weight: 600;\n  color: var(--text-mid);\n  margin-bottom: 6px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.9rem;\n  color: var(--text-dark);\n  background: var(--white);\n  outline: none;\n  transition: border-color 0.2s;\n  appearance: none;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  border-color: var(--teal);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 110px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.form-submit {\n  width: 100%;\n  padding: 14px;\n  background: var(--navy);\n  color: var(--white);\n  border: none;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.form-submit:hover:not(:disabled) {\n  background: var(--teal);\n  color: var(--navy);\n}\n\n.form-submit:disabled {\n  cursor: default;\n  opacity: 0.96;\n}\n\n.contact-info h3 {\n  font-family: var(--font-display);\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--navy);\n  margin-bottom: 1rem;\n}\n\n.contact-info p {\n  color: var(--text-mid);\n  font-size: 0.95rem;\n  line-height: 1.75;\n  margin-bottom: 2rem;\n}\n\n.contact-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.ci-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: var(--sky);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.ci-text p {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  margin-bottom: 2px;\n}\n\n.ci-text strong {\n  font-size: 0.9rem;\n  color: var(--navy);\n}\n\n.whatsapp-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: #25d366;\n  color: var(--white);\n  padding: 13px 26px;\n  border-radius: 50px;\n  font-weight: 700;\n  font-size: 0.9rem;\n  text-decoration: none;\n  margin-top: 0.5rem;\n}\n\n.whatsapp-btn:hover {\n  background: #1eb85a;\n  transform: translateY(-2px);\n}\n\nfooter {\n  background: var(--navy);\n  color: rgba(255, 255, 255, 0.5);\n  padding: 2rem 6%;\n  text-align: center;\n  font-size: 0.82rem;\n}\n\n.footer-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.footer-logo {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 1.1rem;\n  color: var(--white);\n}\n\n.footer-logo span {\n  color: var(--teal);\n}\n\nfooter a {\n  color: rgba(255, 255, 255, 0.5);\n  text-decoration: none;\n}\n\nfooter a:hover {\n  color: var(--teal);\n}\n\n.fade-up {\n  opacity: 0;\n  transform: translateY(28px);\n  animation: fadeUp 0.6s ease-out forwards;\n}\n\n@keyframes fadeUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.delay-1 {\n  animation-delay: 0.1s;\n}\n\n.delay-2 {\n  animation-delay: 0.2s;\n}\n\n.delay-3 {\n  animation-delay: 0.3s;\n}\n\n@media (max-width: 900px) {\n  .hero-inner {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-visual {\n    max-width: 500px;\n    margin: 0 auto;\n  }\n\n  .steps {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .steps::before {\n    display: none;\n  }\n\n  .contacto-inner {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 650px) {\n  nav {\n    padding: 0 4%;\n  }\n\n  .nav-links {\n    display: none;\n  }\n\n  section {\n    padding: 60px 5%;\n  }\n\n  .hero {\n    padding: 100px 5% 60px;\n  }\n\n  .steps {\n    grid-template-columns: 1fr;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .hero h1 {\n    font-size: 2.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
